import React, { useEffect, useState } from 'react'
import LeftNav from './components/LeftNav/LeftNav'
import TopNav from './components/TopNav/TopNav'
import { Text } from '@sede-enterprise/shell-ds-react-framework';

const Layout = ({ children }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const version = "2.0.1"

    // useEffect(() => {
    //     c3request("CarmaConfig", "configValue", { path: "AppVersion" }).then((res) => {
    //         setversion(res.value);
    //     });
    // }, []);

    const displayFooter = (
        <div
            style={{
                textAlign: "right",
                padding: "10px 30px",
            }}
        >
            <Text style={{ margin: "0px" }}>Version {version}</Text>
        </div>
    );

    return (
        <>
            <LeftNav setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
            <TopNav />
            <main id="layout-id-1" style={{ marginLeft: isExpanded ? "30px" : "0px" }}>
                {children}
            </main>
            <footer>
                {version && displayFooter}
            </footer>
        </>
    )
}

export default Layout